export default __webpack_public_path__ + "static/media/paywallAvatar.3e102238.svg";